import { useMemo, useState } from 'react';
import { useReactFlow } from 'reactflow';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

function findADsWithRoles(nodes, roles) {
    return nodes.filter(
        (node) => (node.type === 'ad' || node.type === 'tech_tour_ad') && roles.includes(node.data.ad_role),
    );
}

const ADNodeSelect = ({ node, field, fullWidth }) => {
    const [selectedADNodeId, setSelectedADNodeId] = useState(node.data[field] || '');
    const reactFlow = useReactFlow();
    const { t } = useTranslation();
    const isError = !selectedADNodeId;

    const nodesToSelect = useMemo(() => {
        const nodes = reactFlow.getNodes();
        const mapFieldToRoles = {
            forest_root_id: ['forest'],
            parent_domain_id: ['tree'],
            target_domain_id: ['forest', 'tree', 'child'],
        };

        return findADsWithRoles(nodes, mapFieldToRoles[field]);
    }, [field, reactFlow]);

    const handleUpdateADNodeId = (e) => {
        const value = e.target.value;
        setSelectedADNodeId(value);
        node.data[field] = value;
    };

    return (
        <FormControl error={isError} sx={{ width: fullWidth ? '100%' : '45%' }} size="small">
            <InputLabel id={`${field}-label`}>{t(`${field}_name`)}</InputLabel>
            <Select
                labelId={`${field}-label`}
                id={field}
                value={selectedADNodeId}
                label={t(`${field}_name`)}
                onChange={handleUpdateADNodeId}
            >
                {!nodesToSelect.length && (
                    <Box sx={{ mx: 1, fontStyle: 'italic', color: 'grey' }}>{t('no_ad_nodes_found')}</Box>
                )}
                {nodesToSelect.map((node) => (
                    <MenuItem key={node.id} value={node.id}>
                        {`${node.data.name} (${node.data.ad_role})`}
                    </MenuItem>
                ))}
            </Select>
            {isError && <FormHelperText>{t('field_is_required')}</FormHelperText>}
        </FormControl>
    );
};

export default ADNodeSelect;
